import { Component, OnInit } from '@angular/core';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { fuseAnimations } from '@fuse/animations';
import { NgxSpinnerService } from 'ngx-spinner';
import { ScrumboardService } from '../../scrumboard.service';

@Component({
  selector: 'app-sprint-dashboard',
  templateUrl: './sprint-dashboard.component.html',
  styleUrls: ['./sprint-dashboard.component.scss'],
  animations: fuseAnimations
})
export class SprintDashboardComponent implements OnInit {

  single: any[];
  multi: any[];
  view: any[] = [750, 70];
  // options
  // showXAxis = true;
  // showYAxis = true;
  gradient = false;
  showLegend = true;
  // showXAxisLabel = true;
  // xAxisLabel = 'Country';
  // showYAxisLabel = true;
  // yAxisLabel = 'Population';

  colorScheme = {
    domain: ['#1D7DC1', '#dede2a', 'green', '#AAAAAA']
  };
  data: any;
  taskoptions: any;
  bugoptions: any;
  activities = [];
  rowData = [];
  profileId: any;
  projectId: any;
  sprintCount: any;
  listOfSprintIds = [];
  projectName: any;
  listOfTaskType = [];
  projectMembers = [];
  selectedProject: any = { name: '', id: '' };
  boardId: any;
  sprintName: any;
  statusOfSprint: any;
  taskTypeList = [];
  activeSprintBoardId: any;
  activeSprintName: any;
  activeSprintStartDate: any;
  activeSprintEndDate: any;
  totalEstimatedHours: string;
  totalCompletedHours: string;
  priorityValue = [];
  labelList = [];
  showFilter: boolean;
  projectStartDate: any;
  projectEndDate: any;
  taskPieGaphData: { labels: any[]; datasets: { data: any[]; backgroundColor: string[]; hoverBackgroundColor: string[]; }[]; };
  bugPieGaphData: { labels: any[]; datasets: { data: any[]; backgroundColor: string[]; hoverBackgroundColor: string[]; }[]; };
  backlogBoardId: any;
  projectMembersList = [];
  imageURL = 'assets/images/avatars/profile.jpg';
  constructor(private parseService: ParseService,
    private queryInterface: QueryInterface,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private _scrumboardService: ScrumboardService
  ) {

    this.taskoptions = {
      title: {
        display: true,
        text: 'Active Sprint Task by priority',
        // text: 'My task',
        fontSize: 16
      },
      legend: {
        position: 'top'
      }
    }

    this.bugoptions = {
      title: {
        display: true,
        text: 'Active Sprint Bug by priority',
        // text: 'My task',
        fontSize: 16
      },
      legend: {
        position: 'top'
      }
    }
  }


  ngOnInit() {
    this.spinner.show();
    this.profileId = this.parseService.instance.User.current().get('profile').id;
    this.route.params.subscribe(async params => {
      this.projectId = params.boardId;
      this.projectName = params.boardUri;
      await this.getBacklogBoardId();
      await this.getSprintList();
      this.getLabels();

      this.getTaskTypeList();
      this.getActivities();
      this.getProMembers(this.projectId);

      this.getProjectInformation();
      this.spinner.hide();
    });

  }

  async getBacklogBoardId() {
    let queryInstance = this.parseService.instance.Object.extend('Sprint');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('project');
    query.equalTo('project', {
      __type: 'Pointer',
      className: 'Project',
      objectId: this.projectId
    });
    query.equalTo('name', 'Backlogs');
    await query.find().then(results => {
      this.backlogBoardId = results[0].id
      this.getWorkItems();
    });
  }

  toggleFilter() {
    this.showFilter = !this.showFilter;
  }

  async getProMembers(projectId) {
    await this._scrumboardService.getProjectMembers(projectId).then(async results => {
      results.forEach(element => {
        this.projectMembers.push({
          profileId: element.get('user').get('profile').id,
          userName: element.get('user').get('profile').get('firstName') + ' ' + element.get('user').get('profile').get('lastName'),
          userImage: element.get('user').get('profile').get('profileImageInfo').url,
        })
      });
    });
  }

  async getWorkItems() {
    this.rowData = [];
    let array = [];
    let i = 0;
    let queryInstance = this.parseService.instance.Object.extend('Tasks');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('Project', {
      __type: 'Pointer',
      className: 'Project',
      objectId: this.projectId
    });
    query.notEqualTo('sprintId', {
      __type: 'Pointer',
      className: 'Sprint',
      objectId: this.backlogBoardId
    });
    query.include('scrumboardList');
    query.include('sprintId');
    query.find().then(results => {
      results.forEach(async element => {
        let assignee = await this.taskRelation(element.get('assignee'));
        let cardStatus = element.get('scrumboardList');

        let employee = assignee.filter(x => x.profileId == this.profileId);
        let estiHours = this.secondsToHms(element.get('estimatedHours'));
        let sprintId = element.get('sprintId')

        if (employee.length > 0 && cardStatus.get('name') != 'Closed') {
          i = i + 1;
          array.push({
            position: i,
            objectId: element.id,
            listId: element.get('scrumboardList').id,
            sprintId: sprintId != undefined ? sprintId.id : '',
            sprintStatus: sprintId != undefined ? sprintId.get('name') : '',
            title: element.get('title'),
            priority: element.get('taskType'),
            assignee: assignee,
            status: cardStatus != undefined ? cardStatus.get('name') : '',
            typeOfTask: element.get('typeOfTask'),
            cardNumber: element.get('cardNumber'),
            updatedAt: element.get('updatedAt'),
            createdAt: element.get('createdAt'),
            taskRole: element.get('taskRole'),
            estimatedHours: estiHours
          });
        }
        this.rowData = array.filter((x, i, a) => a.indexOf(x) == i);
      });
    })
  }

  async taskRelation(tasks) {
    let assignee = [];
    await tasks.query().each(innerElement => {
      assignee.push({
        name: innerElement.get('firstName') + ' ' + innerElement.get('lastName'),
        profileId: innerElement.id,
        profilePic: innerElement.get('profileImageInfo').url
      });
    });
    return assignee;
  }

  secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = (h <= 9 ? '0' : '') + h;
    var mDisplay = (m <= 9 ? '0' : '') + m;
    var sDisplay = (s <= 9 ? '0' : '') + s;
    return hDisplay + ':' + mDisplay;
  }

  async getLabels() {
    this.listOfTaskType = [];
    this.labelList = [];
    await this._scrumboardService.getLabels().then(async res => {
      let result = res[0];
      this.labelList = result.get('taskType');
      result.get('typeOfTask').forEach(element => {
        this.listOfTaskType.push(element.typeOfTask);
      });
    });
  }

  commonFilter() {
    if (this.priorityValue.length > 0) {
      this.rowData = [];
      let array = [];
      let i = 0;
      let queryInstance = this.parseService.instance.Object.extend('Tasks');
      let query = new this.parseService.instance.Query(queryInstance);
      query.equalTo('Project', {
        __type: 'Pointer',
        className: 'Project',
        objectId: this.projectId
      });
      query.notEqualTo('sprintId', {
        __type: 'Pointer',
        className: 'Sprint',
        objectId: this.backlogBoardId
      });
      query.include('scrumboardList');
      query.include('sprintId');
      query.find().then(results => {
        results.forEach(async element => {
          let assignee = await this.taskRelation(element.get('assignee'));
          let eventArray = [];
          let condition;
          if (this.priorityValue.length > 0) {
            eventArray = this.priorityValue;
            condition = element.get('taskType');
          }
          eventArray.forEach(innerelement => {
            if (condition == innerelement) {
              let cardStatus = element.get('scrumboardList');

              let employee = assignee.filter(x => x.profileId == this.profileId);
              let estiHours = this.secondsToHms(element.get('estimatedHours'));

              if (employee.length > 0 && cardStatus.get('name') != 'Closed') {
                i = i + 1;
                array.push({
                  position: i,
                  objectId: element.id,
                  sprintId: element.get('scrumboardList').id,
                  title: element.get('title'),
                  priority: element.get('taskType'),
                  assignee: assignee,
                  status: cardStatus != undefined ? cardStatus.get('name') : '',
                  typeOfTask: element.get('typeOfTask'),
                  cardNumber: element.get('cardNumber'),
                  updatedAt: element.get('updatedAt'),
                  createdAt: element.get('createdAt'),
                  taskRole: element.get('taskRole'),
                  estimatedHours: estiHours
                });
              }
              this.rowData = array.filter((x, i, a) => a.indexOf(x) == i);
            }
          });
        });
      });
    }
    else {
      this.getWorkItems()
    }
  }


  async searchTask(event): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.rowData = [];
      let array = [];
      let i = 0;
      if (event != undefined && event != '') {
        let titleQueryInstance = this.parseService.instance.Object.extend('Tasks');
        let titleQuery = new this.parseService.instance.Query(titleQueryInstance);
        titleQuery.equalTo('Project', {
          __type: 'Pointer',
          className: 'Project',
          objectId: this.projectId
        });
        titleQuery.include('scrumboardList');
        titleQuery.contains('title', event);
        titleQuery.descending('updatedAt');
        titleQuery.notEqualTo('sprintId', {
          __type: 'Pointer',
          className: 'Sprint',
          objectId: this.backlogBoardId
        });
        let cardNoQueryInstance = this.parseService.instance.Object.extend('Tasks');
        let cardNoQuery = new this.parseService.instance.Query(cardNoQueryInstance);
        cardNoQuery.equalTo('Project', {
          __type: 'Pointer',
          className: 'Project',
          objectId: this.projectId
        });
        cardNoQuery.include('scrumboardList');
        cardNoQuery.equalTo('cardNumber', Number(event));
        cardNoQuery.descending('updatedAt');
        cardNoQuery.notEqualTo('sprintId', {
          __type: 'Pointer',
          className: 'Sprint',
          objectId: this.backlogBoardId
        });
        await Promise.all([titleQuery.find(), cardNoQuery.find()]).then(([title, cardNo]) => {
          function secondsToHms(d) {
            d = Number(d);
            var h = Math.floor(d / 3600);
            var m = Math.floor(d % 3600 / 60);
            var s = Math.floor(d % 3600 % 60);

            var hDisplay = (h <= 9 ? '0' : '') + h;
            var mDisplay = (m <= 9 ? '0' : '') + m;
            var sDisplay = (s <= 9 ? '0' : '') + s;
            return hDisplay + ':' + mDisplay;
          }
          if (title.length > 0) {
            title.forEach(async element => {
              const getRelationAssignee = async function (tasks) {
                let assignee = [];
                await tasks.query().each(innerElement => {
                  assignee.push({
                    name: innerElement.get('firstName') + ' ' + innerElement.get('lastName'),
                    profileId: innerElement.id,
                    profilePic: innerElement.get('profileImageInfo').url
                  });
                });
                return assignee;
              }
              let assignee = await getRelationAssignee(element.get('assignee'));
              let cardStatus = element.get('scrumboardList');

              let employee = assignee.filter(x => x.profileId == this.profileId);
              let estiHours = secondsToHms(element.get('estimatedHours'));

              if (employee.length > 0 && cardStatus.get('name') != 'Closed') {
                i = i + 1;
                array.push({
                  position: i,
                  objectId: element.id,
                  sprintId: element.get('scrumboardList').id,
                  title: element.get('title'),
                  priority: element.get('taskType'),
                  assignee: assignee,
                  status: cardStatus != undefined ? cardStatus.get('name') : '',
                  typeOfTask: element.get('typeOfTask'),
                  cardNumber: element.get('cardNumber'),
                  updatedAt: element.get('updatedAt'),
                  createdAt: element.get('createdAt'),
                  taskRole: element.get('taskRole'),
                  estimatedHours: estiHours,
                });
              }

              this.rowData = array.filter((x, i, a) => a.indexOf(x) == i);
            });
          }
          else {
            cardNo.forEach(async element => {
              const getRelationAssignee = async function (tasks) {
                let assignee = [];
                await tasks.query().each(innerElement => {
                  assignee.push({
                    name: innerElement.get('firstName') + ' ' + innerElement.get('lastName'),
                    profileId: innerElement.id,
                    profilePic: innerElement.get('profileImageInfo').url
                  });
                });
                return assignee;
              }
              let assignee = await getRelationAssignee(element.get('assignee'));
              let cardStatus = element.get('scrumboardList');

              let employee = assignee.filter(x => x.profileId == this.profileId);
              let estiHours = secondsToHms(element.get('estimatedHours'));

              if (employee.length > 0 && cardStatus.get('name') != 'Closed') {
                i = i + 1;
                array.push({
                  position: i,
                  objectId: element.id,
                  title: element.get('title'),
                  priority: element.get('taskType'),
                  assignee: assignee,
                  status: cardStatus != undefined ? cardStatus.get('name') : '',
                  typeOfTask: element.get('typeOfTask'),
                  cardNumber: element.get('cardNumber'),
                  updatedAt: element.get('updatedAt'),
                  createdAt: element.get('createdAt'),
                  taskRole: element.get('taskRole'),
                  estimatedHours: estiHours
                });
              }

              this.rowData = array.filter((x, i, a) => a.indexOf(x) == i);
            });
          }
        });

      } else {
        this.getWorkItems();
      }
    });
  }

  async getSprintList() {
    this.listOfSprintIds = [];
    let queryInstance = this.parseService.instance.Object.extend('Sprint');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('project');
    query.equalTo('project', {
      __type: 'Pointer',
      className: 'Project',
      objectId: this.projectId
    });
    await query.find().then(results => {
      this.sprintCount = results.length;
      results.forEach(element => {
        this.listOfSprintIds.push(element.id)
      });
    });
  }

  async getActivities() {
    this.activities = [];
    let result = [];
    let condition = [
      { condition: 'descending', field: 'createdAt' },
      { condition: 'limit', value: 500000 },
      { condition: 'include', value: 'updatedBy' },
      { condition: "equalTo", field: "moduleType", value: 'Sprint' },
      { condition: "containedIn", field: "updatedId", value: this.listOfSprintIds }]

    await this.queryInterface.executeQuery(this.parseService, 'ActivityCenter', condition).then(results => {
      results.forEach(async (element, index) => {
        let name;
        let queryInstance = this.parseService.instance.Object.extend('Sprint');
        let query = new this.parseService.instance.Query(queryInstance);
        query.equalTo('objectId', element.get('updatedId'));
        await query.find().then(res => {
          let sprintResult = res[0];
          name = sprintResult.get('name');
        });
        result.push({
          message: element.get('message'),
          updatedBy: element.get('updatedBy').get('firstName') + ' ' + element.get('updatedBy').get('lastName'),
          createdAt: element.get('createdAt'),
          updatedUserImage: element.get('updatedBy').get('profileImageInfo').url,
          sprintName: name
        });
        this.activities = result.sort((a, b) => {
          if ((a.createdAt).getTime() > (b.createdAt).getTime()) { return -1; }
          if ((a.createdAt).getTime() < (b.createdAt).getTime()) { return 1; }
        });
      });
    });
  }


  async getTaskTypeList() {
    this.taskTypeList = [];
    let queryInstance = this.parseService.instance.Object.extend('DataSettings');
    let query = new this.parseService.instance.Query(queryInstance);
    await query.find().then(results => {
      let result = results[0];
      result.get('taskType').forEach(element => {
        this.taskTypeList.push(element.taskType);
      });
    });
    this.getActiveSprintBoardId();
  }

  async getActiveSprintBoardId() {
    let graphResults = [];
    let totalEstimatedHours = 0;
    let totalCompletedHours = 0;
    let queryInstance = this.parseService.instance.Object.extend('Sprint');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('project');
    query.equalTo('project', {
      __type: 'Pointer',
      className: 'Project',
      objectId: this.projectId
    });
    query.equalTo('status', 'Active');
    query.include('tasks');
    await query.find().then(async results => {
      this.activeSprintBoardId = results[0].id;
      this.activeSprintName = results[0].get('name');
      this.activeSprintStartDate = results[0].get('startDate');
      this.activeSprintEndDate = results[0].get('endDate');
      this.getTaskPieGraph();

      let tasks = results[0].relation('tasks').query();
      tasks.include('scrumboardList')
      await tasks.find().then(taskResult => {

        let assignees = [];
        this.projectMembersList = [];
        taskResult.forEach(async element => {
          let assignee = await this.getAssignees(element.get('assignee'));
          assignee.forEach(res => {
            assignees.push({
              userName: res.name,
              userImage: res.profilePic
            });
          });
          this.projectMembersList = this.uniqBy(assignees, JSON.stringify);
        });

        graphResults = JSON.parse(JSON.stringify(taskResult));
        graphResults.forEach(res => {
          totalEstimatedHours += res.estimatedHours;
          totalCompletedHours += res.completedHours;
        });
        this.totalEstimatedHours = this.secondsToHoursMinutesSeconds(totalEstimatedHours);
        this.totalCompletedHours = this.secondsToHoursMinutesSeconds(totalCompletedHours);
      });
    });
  }

  uniqBy(a, key) {
    var index = [];
    return a.filter(function (item) {
      var k = key(item);
      return index.indexOf(k) >= 0 ? false : index.push(k);
    });
  }

  async getAssignees(tasks) {
    let assignee = [];
    await tasks.query().each(innerElement => {
      assignee.push({
        name: innerElement.get('firstName') + ' ' + innerElement.get('lastName'),
        profileId: innerElement.id,
        profilePic: innerElement.get('profileImageInfo').url
      });
    });
    return assignee;
  }

  secondsToHoursMinutesSeconds(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = (h <= 9 ? '0' : '') + h;
    var mDisplay = (m <= 9 ? '0' : '') + m;
    var sDisplay = (s <= 9 ? '0' : '') + s;
    return hDisplay + ':' + mDisplay + ':' + sDisplay;
  }

  async getTaskPieGraph() {
    this.spinner.show();
    let graphResults = [];
    let queryInstance = this.parseService.instance.Object.extend('Sprint');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('project');
    query.equalTo('objectId', this.activeSprintBoardId);
    query.select('tasks.scrumboardList');
    await query.find().then(async results => {
      this.sprintName = results[0].get('name');
      this.statusOfSprint = results[0].get('status');
      let result = results[0];
      let tasks = result.relation('tasks').query();
      tasks.include('scrumboardList');
      tasks.limit(100000);
      let taskNames = [];
      let taskStatus = [];
      let bugNames = [];
      let bugStatus = [];
      await tasks.find().then(taskResult => {
        graphResults = JSON.parse(JSON.stringify(taskResult));

        let taskGraphResults = graphResults.filter(x => (x.typeOfTask).slice(-1)[0] == 'Task');
        let bugGraphResults = graphResults.filter(x => (x.typeOfTask).slice(-1)[0] == 'Bug');

        this.taskTypeList.forEach(result => {
          let res = taskGraphResults.filter(x => (x.taskType).slice(-1)[0] == result);
          taskNames.push(result);
          taskStatus.push(res.length);
        });

        this.taskPieGaphData = {
          labels: taskNames,
          datasets: [
            {
              data: taskStatus,
              backgroundColor: [
                "#FF6384",
                "#36A2EB",
                "#FFCE56"
              ],
              hoverBackgroundColor: [
                "#FF6384",
                "#36A2EB",
                "#FFCE56"
              ]
            }]
        }

        this.taskTypeList.forEach(result => {
          let res = bugGraphResults.filter(x => (x.taskType).slice(-1)[0] == result);
          bugNames.push(result);
          bugStatus.push(res.length);
        });

        this.bugPieGaphData = {
          labels: bugNames,
          datasets: [
            {
              data: bugStatus,
              backgroundColor: [
                "#FF6384",
                "#36A2EB",
                "#FFCE56"
              ],
              hoverBackgroundColor: [
                "#FF6384",
                "#36A2EB",
                "#FFCE56"
              ]
            }]
        }
        this.spinner.hide();

      });
    });
  }

  getProjectInformation() {
    let queryInstance = this.parseService.instance.Object.extend('Project');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('objectId', this.projectId);
    query.find().then(results => {
      this.projectStartDate = results[0].get('projectInfo').projectStartDate;
      this.projectEndDate = results[0].get('projectInfo').actualCompletionDate;
    });
  }


}
